<template>
  <v-container grid-list-xl>
    <div class="head-title mb-4">
      <h1 class="display-1">Mode propriétaire</h1>
      <p class="subheading grey--text">Mot de passe</p>
    </div>
    <v-layout row wrap>
      <v-flex xs12 sm2></v-flex>
      <v-flex xs12 sm8>
        <v-card class="rel">
          <v-tabs centered v-model="activeTab" slider-color="primary" class="full-w">
            <v-tab ripple>confirmation du mot de passe</v-tab>
            <v-tab ripple>mot de passe oublié</v-tab>
            <v-tab-item>
              <v-card-text>
                <div class="d-flex">
                  <v-text-field
                    placeholder="Confirmez le mot de passe"
                    :type="typePwd"
                    v-model="password"
                    append-icon="check"
                    :prepend-icon="isVisible"
                    @click:prepend="makeItVisible"
                    @keyup.enter="submit('confirm')"
                    @click:append="submit('confirm')">
                  </v-text-field>
                </div>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <div class="d-flex">
                  <v-text-field
                    placeholder="Entrez un numéro de téléphone pour recevoir votre nouveau mot de passe par SMS"
                    type="tel"
                    mask="phone"
                    v-model="tel"
                    append-icon="check"
                    @keyup.enter="submit('send')"
                    @click:append="submit('send')">
                  </v-text-field>
                </div>
              </v-card-text>
            </v-tab-item>
          </v-tabs>
          <div class="floating-btn abs d-flex justify-content-end">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="modal = true" right dark fab top color="primary">
                  <v-icon>create</v-icon>
                </v-btn>
              </template>
              <span>Changer le mot de passe propriétaire</span>
            </v-tooltip>
          </div>
        </v-card>
      </v-flex>
      <v-flex xs12 sm2></v-flex>
      <v-dialog v-model="modal" max-width="400px">
        <v-card>
          <v-card-title>
            <v-icon color="primary" dense class="mr-2">{{ editIcon }}</v-icon>
              <span>Changer le mot de passe</span>
            </v-card-title>
          <v-divider />
          <v-card-text>
            <div class="d-flex">
              <v-text-field
                :type="typePwdUpdate"
                v-model="passwordUpdate"
                append-icon="check"
                :prepend-icon="isVisibleUpdate"
                @click:prepend="makeItVisibleUpdate"
                @keyup.enter="submit('update')">
              </v-text-field>
            </div>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-center">
            <v-btn text @click="modal = false">Annuler</v-btn>
            <v-btn text color="primary" @click="submit('update')">Enregistrer</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
  import { CONFIRM_PASSWORD_PROPRIO, RESET_PASSWORD_PROPRIO, UPDATE_PASSWORD_PROPRIO } from '@/store/actions/modeProprietaire'
  import { mdiBriefcaseEdit } from '@mdi/js';
  export default {
    name: 'ModeProprietaire',
    data: () =>({
      activeTab: null,
      visible: false,
      visibleUpdate: false,
      password: '',
      passwordUpdate: '',
      tel: '',
      modal: false,
      editIcon: mdiBriefcaseEdit
    }),
    methods: {
      submit (mode) {
        switch (mode) {
          case 'confirm':
            this.$store.dispatch(CONFIRM_PASSWORD_PROPRIO, this.password).then(() => {
              location.reload()
            })
            break
          case 'send':
            this.$store.dispatch(RESET_PASSWORD_PROPRIO, this.tel).then(() => {
              location.reload()
            })
            break
          case 'update':
            this.$store.dispatch(UPDATE_PASSWORD_PROPRIO, this.passwordUpdate).then(() => {
              location.reload()
            })
            break
          default :
            break
        }
      },
      makeItVisible () {
        this.visible = !this.visible
      },
      makeItVisibleUpdate () {
        this.visibleUpdate = !this.visibleUpdate
      }
    },
    computed: {
      isVisible () {
        if (this.visible) {
          return 'visibility'
        } else {
          return 'visibility_off'
        }
      },
      isVisibleUpdate () {
        if (this.visibleUpdate) {
          return 'visibility'
        } else {
          return 'visibility_off'
        }
      },
      typePwd () {
        if (this.visible) {
          return 'text'
        } else {
          return 'password'
        }
      },
      typePwdUpdate () {
        if (this.visibleUpdate) {
          return 'text'
        } else {
          return 'password'
        }
      }
    },
  }
</script>
